import {
  Component, Input, ChangeDetectionStrategy, ViewChild, ElementRef,
  ChangeDetectorRef, AfterViewInit, Inject
} from '@angular/core';
import { gsap, Linear } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize, ButtonIconType } from '@design-system/components/molecules/button-icon/entities/button-icon.types';

@Component({
  selector: 'app-slide-recent',
  templateUrl: './slide-recent.component.html',
  styleUrls: ['./slide-recent.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SlideRecentComponent implements AfterViewInit {
  @Input() searches: RecentSearchModel[];
  @Input() index: number;
  @Input() isMobile: boolean;


  @ViewChild('sectionSlideSearch') content: ElementRef;
  @ViewChild('slideRecentSearch') cellHeader: ElementRef;

  public showl = false;
  public showr = false;

  public readonly icon = Icon;
  public readonly buttonIconSize = ButtonIconSize.XL;
  public readonly buttonType = ButtonIconType.Primary;
  
  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    @Inject(IS_BROWSER) public isBrowser: boolean
  ) { }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      this.detectChanges();
    }
  }

  get recentSearchDataType(): typeof RecentSearchDataType {
    return RecentSearchDataType;
  }

  public trackById(index: number, item: RecentSearchModel): string {
    return item._id;
  }

  public previous(): void {
    this.scrollTo(this.content.nativeElement.scrollLeft - this.cellHeader.nativeElement.offsetWidth, 0.5);
  }

  public next(): void {
    this.scrollTo(this.content.nativeElement.scrollLeft + this.cellHeader.nativeElement.offsetWidth, 0.5);
  }

  private detectChanges(): void {
    this.showLeft();
    this.showRight();
  }

  private showLeft(): void {
    this.showl = this.content?.nativeElement.scrollLeft > 0;
    this.changeDetector.detectChanges();
  }

  private showRight(): void {
    this.showr = this.content?.nativeElement.scrollLeft
      + this.content?.nativeElement.clientWidth < this.content?.nativeElement.scrollWidth;
    this.changeDetector.detectChanges();
  }

  private scrollTo(position: number, duration: number): void {
    gsap.registerPlugin(ScrollToPlugin);
    gsap.to(this.content?.nativeElement, {
      duration,
      scrollTo: { x: position },
      ease: Linear.easeNone,
      onComplete: () => this.detectChanges()
    });
  }

}
